import React from "react";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../styles/car-item.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCar,
  faCogs,
  faGasPump,
  faClock,
  faPhone,
  faRoad,
  faSlidersH,
} from "@fortawesome/free-solid-svg-icons";

const CarItem = ({ item }) => {
  const images = item?.images || [];
  const title = item?.title || `${item?.make || ""} ${item?.model || ""}`.trim();

  return (
    <Col lg="4" md="6" sm="12" className="mb-4">
      <div className="car__item fade-effect">
        <div className="car__item-image-wrap">
          {images.length > 0 ? (
            <Carousel
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              showIndicators={false}
              infiniteLoop
              autoPlay
              interval={5000}
              className="car-listing-carousel"
            >
              {images.map((image, index) => (
                <div key={`${image}-${index}`} className="carousel-image-container">
                  <img src={image} alt={`Car ${item?.model || title}`} className="carousel-image" />
                </div>
              ))}
            </Carousel>
          ) : (
            <div className="carousel-image-container empty-state">
              <span>Nu există imagini disponibile</span>
            </div>
          )}

          <div className="price-pill">€{Number(item?.price || 0).toLocaleString("ro-RO")}</div>
        </div>

        <div className="car__item-content">
          <div className="car__item-heading">
            <h4>{item?.make || "Auto"} {item?.model || ""}</h4>
            <span className="car__year">{item?.year || "—"}</span>
          </div>

          <div className="car__badges">
            <span className="spec-badge">
              <FontAwesomeIcon icon={faCogs} /> {item?.engine || "—"}
            </span>
            <span className="spec-badge">
              <FontAwesomeIcon icon={faGasPump} /> {item?.fuel || "—"}
            </span>
            <span className="spec-badge">
              <FontAwesomeIcon icon={faCar} /> {item?.body || "—"}
            </span>
          </div>

          <div className="car__badges">
            <span className="spec-badge">
              <FontAwesomeIcon icon={faSlidersH} /> {item?.transmission || "—"}
            </span>
            <span className="spec-badge">
              <FontAwesomeIcon icon={faRoad} /> {Number(item?.mileage || 0).toLocaleString("ro-RO")} km
            </span>
            <span className="spec-badge">
              <FontAwesomeIcon icon={faClock} /> {item?.year || "—"}
            </span>
          </div>

          <div className="car__actions">
            <Link to={`/cars/${item?.id}`} className="car__item-btn car__btn-details">
              Detalii
            </Link>
            <a href="tel:+40741383836" className="car__item-btn car__btn-contact">
              <FontAwesomeIcon icon={faPhone} /> Suna
            </a>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default CarItem;
